import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//run on load
  $( () => {
    
    // a nice lil tidbit. When you switch to 4k scaling this stops elements with a transition from scaling up weirdly.
    const transitionTimeout = () => {
      const classes = document.body.classList;
      let timer = null;

      window.addEventListener( 'resize' , () => {
        if ( timer ){
          clearTimeout( timer );
          timer = null;
        } else {
          classes.add( 'stop-transition' );
        }

        timer = setTimeout( () => {
          classes.remove( 'stop-transition' );
          timer = null;
        }, 100);

      });
    }

    transitionTimeout();

    // GSAP STUFF
    gsap.registerPlugin( ScrollTrigger );

    setTimeout( () => {
      ScrollTrigger.refresh()
    }, 200 )
    
    let animDuration = 0.73;
    let animStart = 'top 90%';
    let toggleAction = 'play'; //didnt like how restart reverse looked

    if( $( '.fade' ).length ) { 
      // Fade in for non-title content
      const fadeItem = document.querySelectorAll( '.fade' )

      fadeItem.forEach( ( item ) => {
        gsap.fromTo( 
          item, { 
            opacity: 0, 
            y: 50 
          }, {    
            opacity: 1,
            y: 0,
            duration: animDuration,

            scrollTrigger: {
              trigger: item,
              start: animStart,
              toggleActions: toggleAction,
              // markers: true
            }
          }
        );
      });
    }

    if( $( '.waterfall' ).length ) {
      // basic waterfall + fade
      let waterfallItems = document.querySelectorAll( '.waterfall' );
      
      waterfallItems.forEach( ( item ) => {
        gsap.fromTo( 
          $( item ).children(), {
            opacity: 0,
            y: 20 
          }, {
            opacity: 1,
            y: 0,
            duration: 0.625,
            stagger: 0.125,
  
            scrollTrigger: {
              trigger: item,
              start: 'top bottom-=200',
              toggleActions: 'play'
            }
          }
        )
      })
    }

    if ($( '[data-waterfall]' ).length) {
      gsap.set( '[data-waterfall]', { y: 100, opacity: 0 });
    
      ScrollTrigger.batch( '[data-waterfall]', {
        onEnter: elements => {
          gsap.to(elements, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power1.out',
            stagger: {
                from: 0,
                axis: 'x',
                amount: 0.3
            },
            scrollTrigger: {
              trigger: elements,
              start: 'top bottom-=20',
            }
          });
        },
        once: true
      });
    }

    if( $( '.waterfall-images' ).length ) {
      
      let waterfallItems = document.querySelectorAll( '.waterfall-images' );

      waterfallItems.forEach( ( item ) => {
        gsap.fromTo( 
          $( item ).children(), {
            opacity: 0,
            filter: 'blur(1px)',
            // y: "+=-40",
          }, {
            opacity: 1,
            filter: 'blur(0)',
            // y: "+=-20",
            delay: 1,
            duration: 0.825,
            stagger: 0.225,
  
            scrollTrigger: {
              trigger: item,
              start: 'top bottom-=400',
              toggleActions: 'play',
              invalidateOnRefresh: true
            }
          }
        )
      })
    }

    if( $( '.zoom' ).length ) {
      // basic element zoom
      const zoomers = document.querySelectorAll( '.zoom' );

      zoomers.forEach( ( item ) => {
        gsap.fromTo( item, {
          opacity: 0,
          scale: .65
          }, {
            opacity: 1,
            duration: 0.27,
            scale: 1,

            scrollTrigger: {
              trigger: item,
              start: 'top bottom-=200',
              invalidateOnRefresh: true
            }
          }
        );
      })
    }
  })